import React from 'react';
import { connect } from 'react-redux';
import { EligibilityResultsProvider } from "../../Providers";
import { getValidKeys, getApplication } from "../../../../store/Selectors";
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import MobileFormat from "./Format/Mobile";
var Results = function Results(_ref) {
  var applicationLoaded = _ref.applicationLoaded,
    application = _ref.application,
    validKeys = _ref.validKeys,
    onExit = _ref.onExit;
  if (!applicationLoaded) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, null);
  }
  return /*#__PURE__*/React.createElement(EligibilityResultsProvider, {
    application: application,
    validKeys: validKeys
  }, /*#__PURE__*/React.createElement(MobileFormat, {
    onExit: onExit
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var application = getApplication(state);
  var validKeys = getValidKeys(state);
  return {
    applicationLoaded: state.CefApplication.applicationLoaded,
    application: application,
    validKeys: validKeys
  };
};
var connector = connect(mapStateToProps, null);
export default connector(Results);